export function getServiceworkerStatus() {
  try {
    return navigator.serviceWorker.controller?.state || 'unknown'
  } catch {
    return 'unknown'
  }
}
